import { RegionShared } from "@1games-ru/region-shared";
import {
  EstateImprovement,
  EstateLevel,
  EstateLogFilter,
} from "@1games-ru/region-shared/dist/enums/estate/estate";
import { InteriorType } from "@1games-ru/region-shared/dist/enums/interior/interior";
import { PaymentType } from "@1games-ru/region-shared/dist/enums/payment/payment";
import { HomeMenuGetMailTheHouseClientResponse } from "@/core/rpc-mp-provider/home-menu/home-menu-get-mail";
import { HomeMenuGetMailMessagesTheHouseClientResponse } from "@/core/rpc-mp-provider/home-menu/home-menu-get-messages";
import { HomeMenuSendMessageTheHouseClientResponse } from "@/core/rpc-mp-provider/home-menu/home-menu-send-message";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export default class EstateMpProvider {
  public static async getGuestInfo(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetEstateGuestResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateGuestRequest,
      typeof RegionShared.Backend.Responses.GetEstateGuestResponse
    >(RegionShared.Backend.Events.Estate.GetEstateGuest, { estateId });
  }

  public static async getDetails(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetEstateDetailsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateDetailsRequest,
      typeof RegionShared.Backend.Responses.GetEstateDetailsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateDetails, { estateId });
  }

  public static async getRelated(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetEstateRelatedResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateRelatedRequest,
      typeof RegionShared.Backend.Responses.GetEstateRelatedResponse
    >(RegionShared.Backend.Events.Estate.GetEstateRelated, {});
  }

  public static async getSellPrice(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetEstateSellPriceResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateSellPriceRequest,
      typeof RegionShared.Backend.Responses.GetEstateSellPriceResponse
    >(RegionShared.Backend.Events.Estate.GetEstateSellPrice, { estateId });
  }

  public static async sell(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateSellResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateSellRequest,
      typeof RegionShared.Backend.Responses.EstateSellResponse
    >(RegionShared.Backend.Events.Estate.EstateSell, { estateId });
  }

  public static async enter(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.EstateLivingTransitResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateLivingTransitRequest,
      typeof RegionShared.Backend.Responses.EstateLivingTransitResponse
    >(RegionShared.Backend.Events.Estate.EstateLivingTransit, {
      estateId,
    });
  }
  // TODO: DEPRICATED
  // public static async enterGarage(
  //   houseId: number,
  // ): Promise<
  //   | RpcMpProviderFailedResponse
  //   | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.HouseGarageEnterResponse>
  // > {
  //   return RpcMpProvider.getInstance().callServer<
  //     typeof RegionShared.Backend.Requests.HouseGarageEnterRequest,
  //     typeof RegionShared.Backend.Responses.HouseGarageEnterResponse
  //   >(RegionShared.Backend.Events.Estate.HouseGarageEnter, {
  //     houseId,
  //   });
  // }

  // заглушка, гаражей в мвп не будет
  public static async enterGarage(
    houseId: number,
  ): Promise<RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<unknown>> {
    return RpcMpProvider.getInstance().callServer<{ houseId: number }, undefined>(
      "RegionShared.Backend.Events.Estate.HouseGarageEnter",
      {
        houseId,
      },
    );
  }

  public static async buy(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateBuyResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateBuyRequest,
      typeof RegionShared.Backend.Responses.EstateBuyResponse
    >(RegionShared.Backend.Events.Estate.EstateBuy, {
      estateId,
    });
  }

  public static async createTrade(
    estateId: number,
    characterId: number,
    amount: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateTradeResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateTradeRequest,
      typeof RegionShared.Backend.Responses.EstateTradeResponse
    >(RegionShared.Backend.Events.Estate.EstateTrade, {
      estateId,
      characterId,
      amount,
    });
  }

  public static async feePay(
    estateId: number,
    amount: number,
    paymentType: PaymentType,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateFeePayResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateFeePayRequest,
      typeof RegionShared.Backend.Responses.EstateFeePayResponse
    >(RegionShared.Backend.Events.Estate.EstateFeePay, {
      amount,
      estateId,
      paymentType,
    });
  }

  public static async getTenants(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetEstateTenantsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateTenantsRequest,
      typeof RegionShared.Backend.Responses.GetEstateTenantsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateTenants, { estateId });
  }

  public static async removeTenant(
    estateId: number,
    characterId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateTenantRemoveResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateTenantRemoveRequest,
      typeof RegionShared.Backend.Responses.EstateTenantRemoveResponse
    >(RegionShared.Backend.Events.Estate.EstateTenantRemove, { characterId, estateId });
  }

  public static async updateTenant(
    data: typeof RegionShared.Backend.Requests.EstateTenantUpdateRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateTenantUpdateResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateTenantUpdateRequest,
      typeof RegionShared.Backend.Responses.EstateTenantUpdateResponse
    >(RegionShared.Backend.Events.Estate.EstateTenantUpdate, data);
  }

  public static async getMail(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<HomeMenuGetMailTheHouseClientResponse>
  > {
    return RpcMpProvider.getInstance().callClient<undefined, HomeMenuGetMailTheHouseClientResponse>(
      "EstateHouseGetMailBrowserToClient",
      undefined,
    );
  }

  public static async getMailMessages(
    mailId: string,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<HomeMenuGetMailMessagesTheHouseClientResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      string,
      HomeMenuGetMailMessagesTheHouseClientResponse
    >("EstateHouseGetMailMessagesBrowserToClient", mailId);
  }

  public static async sendMailMessage(data: {
    message: string;
    mailId: string;
    userId: string;
  }): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<HomeMenuSendMessageTheHouseClientResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      {
        message: string;
        mailId: string;
        userId: string;
      },
      HomeMenuSendMessageTheHouseClientResponse
    >("EstateHouseSendMessageBrowserToClient", data);
  }

  public static async getDesignVariants(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateLivingDesignVariantsResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateLivingDesignVariantsRequest,
      typeof RegionShared.Backend.Responses.GetEstateLivingDesignVariantsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateLivingDesignVariant, { estateId });
  }

  public static async buyDesignVariant(
    estateId: number,
    interiorPropId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.EstateLivingDesignVariantBuyResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateLivingDesignVariantBuyRequest,
      typeof RegionShared.Backend.Responses.EstateLivingDesignVariantBuyResponse
    >(RegionShared.Backend.Events.Estate.EstateLivingDesignVariantBuy, {
      estateId,
      interiorPropId,
    });
  }

  public static async previewDesignVariant(
    wallInteriorPropId: number,
    furnitureInteriorPropId: number,
    estateId: number,
    interiorPropId: number,
    name: string,
    type: string,
    price: number,
    address: string,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Client.Responses.InteriorLocalEstatePreviewResponse
      >
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.InteriorLocalEstatePreviewRequest,
      typeof RegionShared.Client.Responses.InteriorLocalEstatePreviewResponse
    >(RegionShared.Client.Events.Interior.InteriorLocalEstatePreview, {
      walls: wallInteriorPropId,
      furniture: furnitureInteriorPropId,
      estateId,
      interiorPropId,
      name,
      type,
      price,
      address,
    });
  }

  public static async closePreviewDesignVariant(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Client.Responses.InteriorLocalEstateRenderResponse
      >
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.InteriorLocalEstateRenderRequest,
      typeof RegionShared.Client.Responses.InteriorLocalEstateRenderResponse
    >(RegionShared.Client.Events.Interior.InteriorLocalEstateRender, {});
  }

  public static async lock(
    estateId: number,
    isLocked: boolean,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateLockResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateLockRequest,
      typeof RegionShared.Backend.Responses.EstateLockResponse
    >(RegionShared.Backend.Events.Estate.EstateLock, { estateId, isLocked });
  }

  public static async addTenants(
    estateId: number,
    characterId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateTenantAddResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateTenantAddRequest,
      typeof RegionShared.Backend.Responses.EstateTenantAddResponse
    >(RegionShared.Backend.Events.Estate.EstateTenantAdd, { estateId, characterId });
  }

  public static async setResident(
    estateId: number | null,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateResidentSetResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateResidentSetRequest,
      typeof RegionShared.Backend.Responses.EstateResidentSetResponse
    >(RegionShared.Backend.Events.Estate.EstateResidentSet, { estateId });
  }

  public static async getComplexSectionDetails(
    estateComplexSectionId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateComplexSectionDetailsResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateComplexSectionDetailsRequest,
      typeof RegionShared.Backend.Responses.GetEstateComplexSectionDetailsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateComplexSectionDetails, {
      estateComplexSectionId,
    });
  }

  public static async floorTransit(
    estateComplexSectionId: number,
    floor: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateFloorTransitResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateFloorTransitRequest,
      typeof RegionShared.Backend.Responses.EstateFloorTransitResponse
    >(RegionShared.Backend.Events.Estate.EstateFloorTransit, { estateComplexSectionId, floor });
  }

  public static async getComplexSectionRelated(
    estateComplexSectionId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateComplexSectionRelatedResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateComplexSectionRelatedRequest,
      typeof RegionShared.Backend.Responses.GetEstateComplexSectionRelatedResponse
    >(RegionShared.Backend.Events.Estate.GetEstateComplexSectionRelated, {
      estateComplexSectionId,
    });
  }

  public static async getComplexSectionGuest(
    estateComplexSectionId: number,
    room: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateComplexSectionGuestResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateComplexSectionGuestRequest,
      typeof RegionShared.Backend.Responses.GetEstateComplexSectionGuestResponse
    >(RegionShared.Backend.Events.Estate.GetEstateComplexSectionGuest, {
      estateComplexSectionId,
      room,
    });
  }

  public static async livingTransit(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.EstateLivingTransitResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateLivingTransitRequest,
      typeof RegionShared.Backend.Responses.EstateLivingTransitResponse
    >(RegionShared.Backend.Events.Estate.EstateLivingTransit, {
      estateId,
    });
  }

  public static async streetTransit(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.EstateStreetTransitResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateStreetTransitRequest,
      typeof RegionShared.Backend.Responses.EstateStreetTransitResponse
    >(RegionShared.Backend.Events.Estate.EstateStreetTransit, {
      estateId,
    });
  }

  public static async streetFromFloorTransit(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.EstateStreetFromFloorTransitResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateStreetFromFloorTransitRequest,
      typeof RegionShared.Backend.Responses.EstateStreetFromFloorTransitResponse
    >(RegionShared.Backend.Events.Estate.EstateStreetFromFloorTransit, {});
  }

  public static async getLogs(
    estateId: number,
    page: number,
    filter: EstateLogFilter,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetEstateLogsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateLogsRequest,
      typeof RegionShared.Backend.Responses.GetEstateLogsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateLogs, { estateId, page, filter });
  }

  public static async getImprovements(
    estateId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateImprovementsResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateImprovementsRequest,
      typeof RegionShared.Backend.Responses.GetEstateImprovementsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateImprovements, { estateId });
  }

  public static async buyImprove(
    estateId: number,
    improvement: EstateImprovement,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.EstateImproveResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateImproveRequest,
      typeof RegionShared.Backend.Responses.EstateImproveResponse
    >(RegionShared.Backend.Events.Estate.EstateImprove, { estateId, improvement });
  }

  public static async getInteriors(
    type: InteriorType | null,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetInteriorsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetInteriorsRequest,
      typeof RegionShared.Backend.Responses.GetInteriorsResponse
    >("GetInteriors", { type });
  }

  // выбор типа номера
  public static async getHotelDetails(
    hotelId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateHotelDetailsResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateHotelDetailsRequest,
      typeof RegionShared.Backend.Responses.GetEstateHotelDetailsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateHotelDetails, { hotelId });
  }

  // Выбор номера из 100
  public static async getHotelElevator(
    hotelId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateHotelElevatorResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateHotelElevatorRequest,
      typeof RegionShared.Backend.Responses.GetEstateHotelElevatorResponse
    >(RegionShared.Backend.Events.Estate.GetEstateHotelElevator, { hotelId });
  }

  // Управление номером
  public static async getHotelRoomDetails(
    hotelId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetEstateHotelRoomDetailsResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetEstateHotelRoomDetailsRequest,
      typeof RegionShared.Backend.Responses.GetEstateHotelRoomDetailsResponse
    >(RegionShared.Backend.Events.Estate.GetEstateHotelRoomDetails, { hotelId });
  }

  // 1й экран бегунок/оплата
  // Для 2го будет estateFeePay
  public static async hotelRoomRent(
    hotelId: number,
    level: EstateLevel,
    paidDays: number,
    paymentType: PaymentType,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.EstateHotelRoomRentResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.EstateHotelRoomRentRequest,
      typeof RegionShared.Backend.Responses.EstateHotelRoomRentResponse
    >(RegionShared.Backend.Events.Estate.EstateHotelRoomRent, {
      hotelId,
      level,
      paidDays,
      paymentType,
    });
  }

  public static async getFridge(
    data: typeof RegionShared.Backend.Requests.FridgeGetFridgeRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FridgeGetFridgeResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FridgeGetFridgeRequest,
      typeof RegionShared.Backend.Responses.FridgeGetFridgeResponse
    >(RegionShared.Backend.Events.Fridge.GetFridge, data);
  }

  public static async restock(
    data: typeof RegionShared.Backend.Requests.FridgeRestockRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FridgeRestockResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FridgeRestockRequest,
      typeof RegionShared.Backend.Responses.FridgeRestockResponse
    >(RegionShared.Backend.Events.Fridge.Restock, data);
  }

  public static async craftItem(
    data: typeof RegionShared.Backend.Requests.FridgeCraftItemRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FridgeCraftItemResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FridgeCraftItemRequest,
      typeof RegionShared.Backend.Responses.FridgeCraftItemResponse
    >(RegionShared.Backend.Events.Fridge.CraftItem, data);
  }

  public static async upgradeFridge(
    data: typeof RegionShared.Backend.Requests.FridgeBuyUpgradeRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FridgeBuyUpgradeResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FridgeBuyUpgradeRequest,
      typeof RegionShared.Backend.Responses.FridgeBuyUpgradeResponse
    >(RegionShared.Backend.Events.Fridge.BuyUpgrade, data);
  }

  public static async createOrderDelivery(
    data: typeof RegionShared.Backend.Requests.FridgeCreateDeliveryRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FridgeCreateDeliveryResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FridgeCreateDeliveryRequest,
      typeof RegionShared.Backend.Responses.FridgeCreateDeliveryResponse
    >(RegionShared.Backend.Events.Fridge.CreateOrderDelivery, data);
  }
}
